'use strict';

import React, { Component } from 'react';

import CTAButton from "../presentational/CTAButton";

export default class CTAButtonContainer extends Component {
  constructor() {
    super();
    this.state = {
    //no state
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  render() {
    const { url, text, containerStyle,buttonStyle } = this.props;
    return (
        <CTAButton
          url={url}
          text={text}
          handleChange={this.handleChange}
          buttonStyle={buttonStyle}
          containerStyle={containerStyle}
        />
    );
  }
}
